import { render, staticRenderFns } from "./StaffOnboardCustomerView.vue?vue&type=template&id=6fa8c04f&scoped=true"
import script from "./StaffOnboardCustomerView.vue?vue&type=script&lang=js"
export * from "./StaffOnboardCustomerView.vue?vue&type=script&lang=js"
import style0 from "./StaffOnboardCustomerView.vue?vue&type=style&index=0&id=6fa8c04f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa8c04f",
  null
  
)

export default component.exports